module.exports = __webpack_public_path__ + "img/31200.a9bc5b37.jpg";